import _ from 'underscore';
const {Backbone} = require('backboneAdapter');
import GenericModel from 'js/models/generic.model';
require('l10n');

    export default GenericModel.extend({
        idAttribute: 'creditId',
        defaults: {
            subscriptionId: 0,
            firstName: null,
            lastName: null,
            email: null,
            msisdn: null,
            creationDate: null,
            campaignTitle: null,
            surveyCode: null,
            filledInNumber: 0,
            pageTitleText: null,
            pageText: null,
            footerText: null,
            backgroundColor: null,
            fontColor: null,
            components: []
        }
    });
